// utils/setupScrollRefresh.js
export function setupScrollRefresh({ smoother } = {}) {
  let t = null;

  const refreshAll = (why = "manual") => {
    // optional logs – great while debugging; remove later
    // console.log("[refreshAll]", why);

    try {
      smoother?.refresh?.();
    } catch {}

    if (window.ScrollTrigger) {
      // true = force invalidate measurements
      try {
        ScrollTrigger.refresh(true);
      } catch {}
    }
  };

  const debounce = (why) => {
    if (t) clearTimeout(t);
    t = setTimeout(() => refreshAll(why), 200);
  };

  // Window resize/orientation
  window.addEventListener("resize", () => debounce("window.resize"));
  window.addEventListener("orientationchange", () => debounce("orientationchange"));

  // Visual viewport (mobile browser UI collapsing/expanding)
  if (window.visualViewport) {
    window.visualViewport.addEventListener("resize", () => debounce("visualViewport.resize"));
  }

  // Fonts finishing can reflow layout
  if (document.fonts?.ready) {
    document.fonts.ready.then(() => refreshAll("fonts.ready")).catch(() => {});
  }

  // Images finished (in case you mount late or SSR)
  if (document.readyState === "complete") {
    // already loaded
    setTimeout(() => refreshAll("load-already-complete"), 0);
  } else {
    window.addEventListener("load", () => refreshAll("window.load"), { once: true });
  }

  // Your custom layout change hook
  const onLayoutChanged = () => refreshAll("layout:changed");
  window.addEventListener("layout:changed", onLayoutChanged);

  // Useful GSAP hooks for debugging (optional)
  if (window.ScrollTrigger) {
    ScrollTrigger.addEventListener("refreshInit", () => {
      // console.log("[ScrollTrigger] refreshInit");
    });
    ScrollTrigger.addEventListener("refresh", () => {
      // console.log("[ScrollTrigger] refreshed");
    });
  }

  // Give callers a way to refresh on demand
  return { refreshAll };
}
